var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.12 35.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38,42.36H29.06l0-1v-7.2a3.63,3.63,0,0,0-3.07-3.62,3.52,3.52,0,0,0-2.79.87A3.43,3.43,0,0,0,22,33.93v8.39l-1,0H12.69A1.72,1.72,0,0,1,11,40.64V25a1,1,0,0,1,2,0V40.36h7V33.93a5.4,5.4,0,0,1,1.83-4.05A5.52,5.52,0,0,1,31,34.12v6.24h7L38,25a1,1,0,0,1,2,0v15.3A2.05,2.05,0,0,1,38,42.36Z",
    transform: "translate(-6.44 -6.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44,23.13a1,1,0,0,1-.79-.38,1,1,0,0,1,.18-1.41L25.47,6.76l6.88,4.82V10.42A1.85,1.85,0,0,1,34.2,8.57h2.23a1.85,1.85,0,0,1,1.85,1.85v5l6,6a1,1,0,0,1,0,1.41,1,1,0,0,1-1.41,0l-6-6a1.85,1.85,0,0,1-.54-1.31V10.57H34.35v2.52a1.21,1.21,0,0,1-.65,1.08,1.24,1.24,0,0,1-1.25-.08L25.53,9.24,8.06,22.92A1,1,0,0,1,7.44,23.13Z",
    transform: "translate(-6.44 -6.76)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.7609b19a9a846f82487c121b8b70c493.svg";
export { ForwardRef as ReactComponent };